<template>
    <button @click="subscribe"><slot/></button>
</template>

<script>
import Swal from 'sweetalert2'
import { subscribeToMailChimp } from "../../helpers/email"

export default {
    props: {
        email: {type: String},
        source: {type: String},
        list: {type: String},
    },
    methods: {
        subscribe() {
            let {email, source, list} = this
            subscribeToMailChimp({email, source, list})
            Swal.fire('Subscribed!', 'Thank you for subscribing, we\'ll be in touch! 😉', 'success')
        }
    }
}
</script>
